// Function to set cookies
const setConsentCookies = (shopifyConsent, rolexConsent) => {
    if (shopifyConsent !== 'skip') {
        document.cookie = `shopify-cookies-consent=${shopifyConsent}; path=/; SameSite=Lax; Secure`;
    }
    document.cookie = `rlx-consent=${rolexConsent}; path=/; SameSite=Lax; Secure`;
    console.log(`Cookies updated: shopify-cookies-consent=${shopifyConsent}, rlx-consent=${rolexConsent}`);
};

// Function to get the value of a cookie
const getCookie = (name) => {
    const cookies = document.cookie.split('; ');
    const cookie = cookies.find(row => row.startsWith(`${name}=`));
    return cookie ? cookie.substring(name.length + 1) : null;
};

// Sync Shopify consent with Rolex consent
const syncConsentWithShopify = () => {
    const shopifyCookie = getCookie('shopify-cookies-consent');
    const rolexCookie = getCookie('rlx-consent');

    if (!shopifyCookie) {
        console.log('No shopify-cookies-consent cookie found.');
        return;
    }

    let adobetrackingConsent = 'wait';

    // Parse Shopify consent cookie
    const services = shopifyCookie.split('!');
    for (let service of services) {
        if (service.startsWith('adobetracking=')) {
            adobetrackingConsent = service.split('=')[1];
            break;
        }
    }

    // Sync Rolex consent only if it differs from Shopify consent
    if (adobetrackingConsent === 'true' && rolexCookie !== 'true') {
        setConsentCookies('skip', 'true');
        console.log('rlx-consent set to true (adobetracking accepted).');
    } else if (adobetrackingConsent === 'false' && rolexCookie !== 'false') {
        setConsentCookies('skip', 'false');
        console.log('rlx-consent set to false (adobetracking denied).');
    } else {
        console.log('rlx-consent remains unchanged.');
    }
};

// Function to load the Adobe script
const loadAdobeScript = () => {
    const adobeScript = document.createElement('script');
    adobeScript.src = "//assets.adobedtm.com/7e3b3fa0902e/7ba12da1470f/launch-5de25e657d80.min.js";
    document.head.appendChild(adobeScript);
    console.log("Adobe script loaded.");
};

// Initialize `rlx-consent` on first visit if not already present
if (!getCookie('rlx-consent')) {
    setConsentCookies(getCookie('shopify-cookies-consent') || 'false', 'false');
    console.log("Initial `rlx-consent` set to false.");
}

// Function to update `rlx-consent` cookie
const setRlxConsentCookie = (status) => {
    document.cookie = `rlx-consent=${status ? 'true' : 'false'}; path=/; SameSite=Lax; Secure`;
    console.log(`rlx-consent set to: ${status ? 'true' : 'false'}`);
};

// Sync consent after page load
document.addEventListener('DOMContentLoaded', syncConsentWithShopify);

// Always load the Tarteaucitron script
const loadTarteaucitronScript = () => {
    const script = document.createElement('script');
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/tarteaucitronjs/1.19.0/tarteaucitron.js";
    script.integrity = "sha512-rVB1I2mKTuNzXSpRihvpiThlIPCJ0O5mywAtlKOV9VR5lnaffr5CZbpxxMcD/uxabzHl+nocgsPRPdeux0ED3Q==";
    script.crossOrigin = "anonymous";
    script.referrerPolicy = "no-referrer";
    script.async = true;
    console.log('Loading tarteaucitron script...');

    script.onload = () => {
        console.log('Tarteaucitron script loaded.');
      
         tarteaucitronCustomText = {
                      "acceptAll": "Accept All",
                      "denyAll": "Deny All",
                      "analytic": {
                          "title": "Analytics & Statistics",
                          "details": "The analytics & statistics services used to generate useful statistics attendance to improve the site."
                      },
                      "mandatoryTitle": "Essential",
                      "mandatoryText": "This site uses some cookies necessary for its proper functioning which cannot be deactivated.",
                  };
      
        tarteaucitron.services.adobetracking = {
                      "key": "adobetracking",
                      "type": "analytic",
                      "name": "Adobe Analytics Tracking",
                      "needConsent": true,
                      "cookies": [],
                      "readmoreLink": "https://www.rolex.com/en-us/legal-notices/cookies",
                      "url": null,
                      "js": function () {
                          const expires = new Date(Date.now() + 365 * 864e5).toUTCString();
                          document.cookie = `rlx-consent=true; expires=${expires}; path=/; SameSite=Lax; Secure`;
                          console.log("rlx-consent cookie set to true from service.");
                      },
                      "fallback": function () {
                          console.log("Adobe Analytics tracking script not loaded due to lack of consent.");
                      },
                  };

        tarteaucitron.init({
            privacyUrl: '/pages/privacy-policy',
            cookieName: 'shopify-cookies-consent',
            orientation: 'bottom',
            groupServices: true,
            showDetailsOnClick: true,
            serviceDefaultState: 'wait',
            DenyAllCta: true,
            AcceptAllCta: true,
            mandatory: true,
            mandatoryCta: true,
            showIcon: false,
            iconPosition: 'BottomRight',
            removeCredit: true,
            moreInfoLink: false,
            googleConsentMode: true,
        });

        // Override respond and respondAll
        const originalRespond = tarteaucitron.respond;
        const originalRespondAll = tarteaucitron.respondAll;

        tarteaucitron.respond = function (el, status) {
            if (el.id.includes('adobetracking')) {
                setRlxConsentCookie(status);
            }
            if (typeof originalRespond === 'function') {
                originalRespond(el, status);
            }
        };

        tarteaucitron.respondAll = function (status, type, allowSafeAnalytics) {
            setRlxConsentCookie(status);
            if (typeof originalRespondAll === 'function') {
                originalRespondAll(status, type, allowSafeAnalytics);
            }
        };

        // Register services
        tarteaucitron.job = tarteaucitron.job || [];
        tarteaucitron.job.push('adobetracking', 'gcmadstorage', 'gcmanalyticsstorage', 'gcmfunctionality', 'gcmadsuserdata', 'gcmsecurity');
    };

    document.head.appendChild(script);
};

// Load Tarteaucitron
loadTarteaucitronScript();
